// extracted by mini-css-extract-plugin
export var brandIcon = "Navbar-module--brand-icon--44916";
export var navIcon = "Navbar-module--nav-icon--aa69c";
export var nav_link = "Navbar-module--nav_link--d1f18";
export var nav_link_top = "Navbar-module--nav_link_top--59b82";
export var navbar = "Navbar-module--navbar--2f7ce";